//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { Retailer } from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';
import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { PDP_URL_VALIDATION_RULES } from '@campaigns/constants/sampling/SamplingRedemptionLocationValidationRulesConstants';
import { useSamplingCampaign } from '@campaigns/hooks/useSamplingCampaign';
import { BodyText, TableHeaderCellText } from '@components/atoms/text/Text';
import { FormFieldController } from '@components/form/field-controller/FormFieldController';
import { FormTextInput } from '@components/form/text-input/FormTextInput';
import { Table } from '@components/organisms/table/Table';
import { TableDataCell } from '@components/organisms/table/TableDataCell';
import { TableRow } from '@components/organisms/table/TableRow';

export const RedemptionLocationFormPdpUrlsFields = () => {
  const { control } = useFormContext<Retailer>();
  const { samplingCampaignRequest } = useSamplingCampaign();

  const products = samplingCampaignRequest?.products ?? [];

  return (
    <div>
      <BodyText>Product Display Page Web Addresses</BodyText>
      <StyledTable
        headerCells={[
          <TableHeaderCellText key='product'>PRODUCT</TableHeaderCellText>,
          <TableHeaderCellText key='pdpUrl'>
            PDP WEB ADDRESS
          </TableHeaderCellText>,
        ]}
        body={products.map((product, index) => {
          return (
            <TableRow key={product.targetCatalogProductId}>
              <TableDataCell>{product.name}</TableDataCell>
              <TableDataCell>
                <FormFieldController
                  control={control}
                  name={`pdpUrls.${index}.pdpUrl`}
                  rules={PDP_URL_VALIDATION_RULES}
                >
                  {(props) => (
                    <FormTextInput
                      {...props}
                      placeholder='Enter PDP web address'
                      trackingId={
                        SAMPLING_CAMPAIGNS_TRACKING_ID.CAMPAIGN_REQUEST_FULFILLMENT_REDEMPTION_LOCATION_PDP_URL_INPUT
                      }
                    />
                  )}
                </FormFieldController>
                <FormFieldController
                  control={control}
                  name={`pdpUrls.${index}.productId`}
                  defaultValue={product.targetCatalogProductId}
                >
                  {(props) => (
                    <input
                      {...props}
                      type='hidden'
                      value={product.targetCatalogProductId}
                    />
                  )}
                </FormFieldController>
              </TableDataCell>
            </TableRow>
          );
        })}
      />
    </div>
  );
};

const StyledTable = styled(Table)`
  margin-top: ${({ theme }) => theme.spacings[3]};
`;
